var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOfIncidentBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 58,
    viewBox: "0 0 43 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4483 0C9.61298 0 0 9.89725 0 22.0826C0 22.5083 0 22.9339 0.0516827 23.4661C0.465144 31.022 3.97957 38.9505 10.5433 47.0917C15.3498 53.0514 20.0012 56.8294 20.2079 56.989L21.5 58L22.7921 56.989C22.9988 56.8294 27.6502 53.0514 32.4567 47.0917C39.0204 38.9505 42.5349 31.022 42.9483 23.4661C43 22.9339 43 22.5083 43 22.0826C42.8966 9.89725 33.2837 0 21.4483 0Z",
    fill: "#25245B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 8.5,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOfIncidentBig);
export default __webpack_public_path__ + "static/media/location-of-incident-big.0d53120b96d1a2b97ad1678052ccfbdb.svg";
export { ForwardRef as ReactComponent };